// extracted by mini-css-extract-plugin
module.exports = {"itemList":"ItemList_itemList__mIout","h4":"ItemList_h4__2LDav","infoItem":"ItemList_infoItem__3RoMq","infoSummary":"ItemList_infoSummary__2_WIT"};